import { UseQueryResult, useQuery } from '@tanstack/react-query'
import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  PublicCompanyLeadData,
  PublicCompanyLeadResponse,
} from '@/features/publicCompanyLeadsFunnel/types/publicCompanyLead'

export const usePublicCompanyLead: (id: string, enabled?: boolean) => UseQueryResult<PublicCompanyLeadData, unknown> = (
  id,
  enabled = true,
) => {
  const privateAxios = usePrivateAxios()

  return useQuery<PublicCompanyLeadResponse, unknown, PublicCompanyLeadData>({
    queryKey: ['publicCompanyLead', id],
    enabled,
    queryFn: () => {
      return privateAxios.get(`/funnel/public/leads/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
